import { UIToolInvocation, UIMessage, UITool } from 'ai';

export class ToolInvocationsContainer {
  constructor(public readonly invocations: UIToolInvocation<UITool>[] = []) {}

  incomplete() {
    return this.invocations.filter((invocation) => {
      // v5: input-streaming or input-available means not yet executed
      return (
        invocation.state === 'input-streaming' ||
        invocation.state === 'input-available'
      );
    });
  }

  complete() {
    return this.invocations.filter((invocation) => {
      // v5: output-available or output-error means executed
      return (
        invocation.state === 'output-available' ||
        invocation.state === 'output-error'
      );
    });
  }

  all(): (UIToolInvocation<UITool> & { status: 'incomplete' | 'complete' })[] {
    return this.invocations.map((invocation) => {
      return {
        ...invocation,
        status:
          invocation.state === 'input-streaming' ||
          invocation.state === 'input-available'
            ? 'incomplete'
            : 'complete',
      };
    });
  }
}

export const makeMessages = (messages: UIMessage[]) => {
  return messages.map((message) => {
    return {
      ...message,
      toolInvocations: new ToolInvocationsContainer(
        message.parts
          ?.filter(
            (part) =>
              typeof part.type === 'string' && part.type.startsWith('tool-')
          )
          .map((part) => part as UIToolInvocation<UITool>) ?? []
      ),
    };
  });
};

export type Message = Omit<UIMessage, 'toolInvocations'> & {
  toolInvocations?: ToolInvocationsContainer;
};
